import { render, staticRenderFns } from "./roomStructureList.vue?vue&type=template&id=04a5889a&scoped=true"
import script from "./roomStructureList.vue?vue&type=script&lang=js"
export * from "./roomStructureList.vue?vue&type=script&lang=js"
import style0 from "./roomStructureList.vue?vue&type=style&index=0&id=04a5889a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a5889a",
  null
  
)

export default component.exports